var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrapper row no-margin",
      staticStyle: { height: "100%", display: "flow-root" }
    },
    [
      _c("header", { staticClass: "row align-items-center no-margin" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "button",
            {
              staticClass: "btn no-bg",
              on: {
                click: function($event) {
                  return _vm.setPosSection("choose-product")
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 mt-3 mb-1 status" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-between" },
          [
            _c("div", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.availabletables")) +
                  " (" +
                  _vm._s(_vm.availableTablesCount) +
                  ")\n      "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "BaseButton",
                  {
                    staticStyle: { position: "relative", top: "-7px" },
                    attrs: { className: "btn-light" },
                    on: { click: _vm.handleClickMoveTable }
                  },
                  [
                    _c("i", { staticClass: "fas fa-exchange-alt" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("apps.pos.button.movetable", {
                            ref_name: _vm.refName
                          })
                        ) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "col-12 no-padding items" },
        [
          _vm.table_number
            ? _c(
                "li",
                {
                  staticClass: "row no-margin item text-danger",
                  class: [{ disabled: _vm.hasDisabledTable }],
                  on: {
                    click: function($event) {
                      return _vm.onStandBy()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _c("i", {
                      staticClass: "fas fa-ban",
                      staticStyle: {
                        "margin-right": "7px",
                        "margin-left": "3px",
                        "font-size": "13px"
                      }
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.deselected")) +
                        "\n      "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.mapTables, function(table, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "row no-margin item",
                class: [].concat(table.classNames),
                on: {
                  click: function($event) {
                    return _vm.onSelectedTable(table.table_number)
                  }
                }
              },
              [
                _c("div", { staticClass: "col" }, [
                  _c("span", [
                    table.table_number == _vm.table_number
                      ? _c("i", { staticClass: "fas fa-arrow-right" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i", { staticClass: "fas fa-circle" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("apps.pos.message.tablenumber", {
                            ref_name: _vm.refName,
                            number: table.table_number
                          })
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isTaken(table.table_number) && _vm.isRenderTime
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-secondary",
                          staticStyle: { position: "relative", top: "-1px" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getDiffTime(table.start_at, {
                                  hours: _vm.$t("message.hours"),
                                  minutes: _vm.$t("message.minutes"),
                                  seconds: _vm.$t("message.seconds")
                                })
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  table.queue_number
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-secondary",
                          staticStyle: { position: "relative", top: "-1px" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("apps.pos.message.queuenumber", {
                                  number: table.queue_number
                                })
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  table.orderCount
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-secondary",
                          staticStyle: { position: "relative", top: "-1px" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("apps.pos.message.orderinqueuecount", {
                                  number: table.orderCount
                                })
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  table.diningName
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-secondary",
                          staticStyle: { position: "relative", top: "-1px" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(table.diningName) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  table.customerName
                    ? _c(
                        "span",
                        {
                          staticClass: "badge badge-secondary",
                          staticStyle: { position: "relative", top: "-1px" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(table.customerName) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-confirm-move-table",
            title: _vm.moveOrderModalTitle,
            hideHeaderClose: true,
            size: "md",
            noFade: "",
            noCloseOnBackdrop: ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                return [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-content-end w-100",
                      staticStyle: { gap: "10px" }
                    },
                    [
                      _c("BaseButton", {
                        attrs: {
                          text: _vm.$t("button.cancel"),
                          className: "btn-sm btn-light"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCloseMoveTable(ok)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BaseButton", {
                        attrs: {
                          text: _vm.$t("button.confirm"),
                          disabled:
                            !_vm.moveToTableNumber ||
                            _vm.moveOrders.length == 0 ||
                            (_vm.table_number != null &&
                              _vm.moveFromTableNumber == null),
                          className: "btn-sm btn-web"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleConfirmMoveTable(ok)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c("div", [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("apps.pos.message.movetablefrom")) +
                    "\n          "
                ),
                _vm.table_number != null
                  ? _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.moveFromTableNumber,
                            expression: "moveFromTableNumber"
                          }
                        ],
                        staticClass:
                          "form-control form-control-sm custom-select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.moveFromTableNumber = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v(_vm._s(_vm.$t("placeholder.select")))
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.moveFromTableOptions, function(
                          table,
                          index
                        ) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: table.value } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(table.text) +
                                  "\n            "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _c("div", [
                      _c(
                        "select",
                        {
                          staticClass:
                            "form-control form-control-sm custom-select",
                          attrs: { disabled: true }
                        },
                        [
                          _c("option", [
                            _vm._v(_vm._s(_vm.$t("message.notselectedtable")))
                          ])
                        ]
                      )
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("apps.pos.message.movetableto")) +
                    "\n          "
                ),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.moveToTableNumber,
                        expression: "moveToTableNumber"
                      }
                    ],
                    staticClass: "form-control form-control-sm custom-select",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.moveToTableNumber = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v(_vm._s(_vm.$t("placeholder.select")))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.moveToTableOptions, function(table, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: table.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(table.text) +
                              "\n            "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _vm.moveToTableNumber
              ? _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("apps.pos.message.moveorderlists")) +
                        " (" +
                        _vm._s(_vm.moveOrders.length) +
                        ")\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "ul",
                      { staticClass: "mb-0" },
                      _vm._l(_vm.moveOrders, function(order, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticStyle: {
                              "list-style": "disc",
                              "margin-left": "15px"
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(order.item) +
                                " x" +
                                _vm._s(order.quantity) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30f4e46f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f4e46f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/include/TableList.vue
// module id = null
// module chunks = 